import { createApp } from "vue";
import FeaturedElement from "../apps/FeaturedElement.vue";

export default () => {
	const app = createApp({});

	Array.prototype.unique = function () {
		return this.filter((value, index, self) => self.indexOf(value) === index);
	};

	// Add last method to Array prototype if it doesn't exist
	if (!Array.prototype.last) {
		Array.prototype.last = function () {
			return this[this.length - 1];
		};
	}

	// Select all elements with the id "font-specimen-block"
	const newAppElements = document.querySelectorAll("#featured-element-canvas");

	newAppElements.forEach((element) => {
		const mediaId = element.getAttribute("data-media");
		createApp(FeaturedElement, { id: mediaId }).mount(element);
	});
};
